import './App.css';
import Collection from './Collection';

function App() {
  return (
    <Collection />
  );
}

export default App;
